module.exports = __webpack_public_path__ + "static/media/photo116.143c009d.jpg";